import React, { Fragment, useState } from 'react';
import { Box, Container, Divider, Grid, Typography } from '@mui/material';

import { makeStyles } from '@mui/styles';

import { ExpandMore } from '@mui/icons-material';

import PrimaryButton from '../../Layouts/MaterialUi/PrimaryButton';
import LazyImage from '../../Layouts/LazyImage';
import Link from '../../Layouts/ActiveLink';

// import HighlightProject from './HighlightProject';
import LearnerProfile from './LearnerProfile';

const OneistoxLearner = ({ heading, learners }) => {
  const classes = useStyle();

  const [viewMore, setViewMore] = useState(9);

  return (
    <Box component="section" py={{ xs: 6, sm: 8 }}>
      <Container>
        <Grid container>
          <Grid item xs={12} md={3}>
            <Box mb={{ xs: 5, sm: 8, md: 10 }}>
              <Typography gutterBottom variant="h4" component="h2">
                {heading?.title}
              </Typography>
              <Typography variant="body1">{heading?.sub}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
      {learners &&
        learners.map(
          (learner, key) =>
            key < viewMore && (
              <Fragment key={key}>
                {learner?.projects && (
                  <Container>
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ mt: '25px', mb: '35px' }}
                    >
                      <Grid item md={6}>
                        <LearnerProfile data={learner?.details} />
                      </Grid>
                      <Grid item md={5} spacing={1} container>
                        {learner?.projects &&
                          learner?.projects.map((project, key) => (
                            <Grid item xs={4} key={key}>
                              <LazyImage
                                radius={2}
                                sizes={sizes}
                                quality={85}
                                className={classes.projectImg}
                                alt={project?.alt}
                                src={`/images/courses/project/${project?.img}`}
                              />
                            </Grid>
                          ))}
                        <Box
                          width={'100%'}
                          textAlign="center"
                          mt={2}
                          display={{ md: 'none' }}
                        >
                          <Link
                            href={`/community/${learner?.details?.profile_url}`}
                          >
                            <PrimaryButton variant="outlined">
                              check out profile
                            </PrimaryButton>
                          </Link>
                        </Box>
                      </Grid>
                    </Grid>
                    <Divider className={classes.divider} />
                  </Container>
                )}

                {/* {learner?.highlight && (
                <Box py={{ md: 5 }} my={5}>
                  <HighlightProject data={learner.highlight} />
                </Box>
              )} */}
              </Fragment>
            ),
        )}
      <Box textAlign="center">
        <PrimaryButton
          onClick={() => setViewMore(viewMore + 6)}
          // color="inherit"
          disabled={viewMore >= learners?.length ? true : false}
          // variant="outlined"
          endIcon={<ExpandMore />}
        >
          View More
        </PrimaryButton>
      </Box>
    </Box>
  );
};

const sizes = {
  xxl: [161, 140, false],
};

export default OneistoxLearner;

const useStyle = makeStyles((theme: any) => ({
  divider: {
    width: '70%',
    '&.MuiDivider-root': {
      margin: '35px auto',
    },
  },
  projectImg: {
    minHeight: '91px',
    '& img': {
      transition: '0.3s',
    },
    '&:hover img': {
      transform: 'scale(1.2)',
    },
  },
  [theme.breakpoints.up('md')]: {
    projectImg: {
      height: '136px',
    },
  },
}));
